import { useEffect } from 'react';
import Loading from './Loading';
import { useNavigate } from 'react-router-dom';
import { get } from '../lib/Api';
import * as Toast from '../lib/Toast.js';
import CallbackLoading from './CallbackLoading';

const OAuthCallback = ({ route }) => {
    // Handle callback and redirect
    const navigate = useNavigate();
    const params = new URL(document.location).searchParams;
    const businessId = params.get('state');

    useEffect(() => {
        get(`${route}${document.location.search}`).then(result => {
            if (result.error) {
                Toast.error(result.error);
            } else if (result.success) {
                Toast.success(result.success);
            } else {
                Toast.error('Unknown error, please try again');
            }

            if (!businessId) {
                navigate(`/`);
            } else if (result.navigate) {
                navigate(`/business/${businessId}/${result.navigate}`);
            } else {
                navigate(`/business/${businessId}/integrations`);
            }
        });
    }, []);

    return <CallbackLoading />;
};

export default OAuthCallback;
